<template>
  <ion-page>
    <ion-content class="page" :fullscreen="true">
      <div v-if="!isLogin">
        <div class="login-title">
          您还未登录，登录后才可以查看
        </div>
        <div>
          <a class="login-button" href="/login">登录</a>
        </div>
      </div>
      <div v-if="isLogin">
        <ion-header>
          <ion-toolbar>
            <ion-buttons slot="start">
              <ion-back-button text="返回" @click="$router.back()"></ion-back-button>
            </ion-buttons>
            <ion-buttons slot="end">
              <ion-back-button text="账单" icon="home-outline" default-href="/tabs/tab2"></ion-back-button>
            </ion-buttons>
            <ion-title>账单详情</ion-title>
          </ion-toolbar>
        </ion-header>
        <div class="activity-info-container">
          <div class="activity-info">
            <div class="activity-bonus-info">
              <div class="activity-customer-info">
                <text class="activity-customer-normal">完成单量：{{ orderAmount }} 单</text>
              </div>
              <div class="activity-customer-info">
                <text
                    class="activity-customer-normal">账单日期：{{ $filters.formatOrderDate(gmtCreate) }}
                </text>
              </div>
              <div class="activity-customer-info">
                <text
                    class="activity-customer-normal">账单号：{{ billNo }}
                </text>
              </div>
              <div class="activity-customer-info">
                <text class="activity-customer-normal">账单费用：{{ billFee }}</text>
              </div>
              <div class="activity-customer-info">
                <text class="activity-customer-normal">支付状态：{{ payStatus === 0 ? '未支付' : '已支付' }}</text>
              </div>
              <div class="activity-customer-info" v-if="payNo">
                <text class="activity-customer-normal">支付方式：{{ $filters.payMethod(payMethod) }}</text>
              </div>
              <div class="activity-customer-info" v-if="payNo">
                <text class="activity-customer-normal">支付流水号：{{ payNo }}</text>
              </div>
            </div>
          </div>
        </div>

        <div id="list" class="list-container">
          <div class="order" v-for="item in orderList" v-bind:detail="item" v-bind:key="item.id">
            <div>
              <div class="order-shop-info">
                <div class="order-shop-sub-info">
                  <div class="order-shop-name">{{ item.shopName }}</div>
                </div>
                <div class="platform-type-logo order-shop-type"
                     v-bind:class="[item.platformType === 1 ? 'meituan-background' : 'eleme-background']">
                </div>
              </div>
              <div class="order-no">
                <div v-if="item.platformType === 1">美团订单号：{{ item.thirdPartyOrderNo }}
                  <div class="shop-name-copy meituan-background-color" @click='copyOrderNo(item.thirdPartyOrderNo)'>
                    复制
                  </div>
                </div>
                <div v-else>饿了么订单号：{{ item.thirdPartyOrderNo }}
                  <div class="shop-name-copy eleme-background-color" @click='copyOrderNo(item.thirdPartyOrderNo)'>
                    复制
                  </div>
                </div>
              </div>
              <div class="order-time-info">
                <div class="order-submit-time">下单时间：{{ $filters.formatOrderDate(item.gmtCreate) }}</div>
              </div>
              <div class="upload-image-list">
                <div class="upload-container" v-viewer>
                  <template v-for="(picture,index) in item.orderPicture" v-bind:detail="picture"
                            v-bind:key="index+'picture'">
                    <img v-if="picture.orderUrl" class="upload-image"
                         :src="picture.orderUrl">
                  </template>
                  <template v-for="(picture,index) in item.commentPicture" v-bind:detail="picture"
                            v-bind:key="index+'picture'">
                    <img v-if="picture.commentUrl" class="upload-image"
                         :src="picture.commentUrl">
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style="height: 100px;">
        </div>

        <!-- 底部按钮 -->
        <div class="button-container" v-if="payStatus === 0">
          <div class="button-half" @click="goAlipay">支付宝支付</div>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import {IonBackButton, IonButtons, IonContent, IonHeader, IonPage, IonTitle, IonToolbar} from '@ionic/vue';
import {getBillDetail, payBillByAlipay} from "../api/bill";
import {useRoute} from "vue-router";
import 'viewerjs/dist/viewer.css'

export default {
  name: 'Tab2',
  components: {
    IonContent, IonPage, IonButtons, IonBackButton, IonTitle, IonToolbar, IonHeader
  },
  data() {
    return {
      isLogin: true,
      page: 1,
      size: 5,
      billId: null,
      longitude: null,
      latitude: null,
      isFromSearch: true,   // 用于判断searchSongList数组是不是空数组，默认true，空的数组
      searchLoading: false, //"上拉加载"的变量，默认false，隐藏
      searchLoadingComplete: false,  //“没有数据”的变量，默认false，隐藏
      indicatorDots: true,
      list: [],
      selected: 0,
      orderList: [],
      timeouts: [],
      countDownList: {},
      countDownDisplayList: {},
      orderAmount: null,
      commissionFee: null,
      billFee: null,
      billNo: null,
      payStatus: null,
      payMethod: null,
      payNo: null,
      gmtCreate: null
    }
  },
  ionViewDidEnter() {
    console.log("进入订单列表")
    this.onShow();
  },
  created() {
    const route = useRoute();
    const {billId} = route.params;
    this.billId = billId;
  },
  methods: {
    onShow: function () {
      this.page = 1;   //第一次加载，设置1
      this.orderList = [];  //放置返回数据的数组,设为空
      this.isFromSearch = true;  //第一次加载，设置true
      this.searchLoading = false;  //把"上拉加载"的变量设为false，不显示
      this.searchLoadingComplete = false //把“没有数据”设为false，隐藏
      this.renderBillOrderList();
    },
    //页面上拉触底事件的处理函数
    searchScrollLower: function ($event) {
      console.log("上拉触底");
      if (!this.searchLoading && !this.searchLoadingComplete) {
        this.page = this.page + 1;  //每次触发上拉事件，把searchPageNum+1
        this.searchLoading = true;   //把"上拉加载"的变量设为false，显示
        this.isFromSearch = false;  //触发到上拉事件，把isFromSearch设为为false
        this.renderBillOrderList();
        $event.target.complete();
      }
      if (this.searchLoadingComplete) {
        $event.target.disabled = true;
      }
    },
    renderBillOrderList: function () {
      console.log('app---renderBillList');
      console.log(this.timeouts);
      for (let i = 0; i < this.timeouts.length; i++) {
        clearInterval(this.timeouts[i]);
      }
      getBillDetail({billId: this.billId}).then(res => {
        if (res.data.length === 0) {
          this.searchLoadingComplete = true;   //把"我是有底线的"的变量设为false，不显示
          this.searchLoading = false;   //把"上拉加载"的变量设为false，不显示
        } else {
          this.searchLoadingComplete = false;   //把"我是有底线的"的变量设为false，不显示
          this.searchLoading = false;   //把"上拉加载"的变量设为false，不显示
        }
        this.orderList = res.data.orderList; //获取数据数组
        this.orderAmount = res.data.orderAmount;
        this.commissionFee = res.data.commissionFee;
        this.billFee = res.data.billFee;
        this.billNo = res.data.billNo;
        this.payStatus = res.data.payStatus;
        this.payMethod = res.data.payMethod;
        this.payNo = res.data.payNo;
        this.gmtCreate = res.data.gmtCreate;
      }).catch(res => {
        console.log(res.data);
        if (res.data.code === 401) {
          this.isLogin = false;
        } else if (res.data.code === 200) {
          this.isLogin = true;
        }
      });
    },
    goAlipay() {
      payBillByAlipay({billId: this.billId}).then(res => {
        const div = document.createElement('div')
        /* 此处form就是后台返回接收到的数据 */
        console.log(res.data.body)
        div.innerHTML = res.data.body
        document.body.appendChild(div)
        document.forms[0].submit()
      }).catch(res => {
        console.log(res);
        console.log(res.data);
        if (res.data.code === 401) {
          this.isLogin = false;
        } else if (res.data.code === 200) {
          this.isLogin = true;
        }
      });
    },
    copyOrderNo(thirdPartyOrderNo) {
      console.log(thirdPartyOrderNo);
      const el = document.createElement('textarea');
      el.value = thirdPartyOrderNo;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }
      alert("复制成功");
    }
  }
}
</script>
<style lang="css">
/* pages/order/list.wxss */
.page {
  --ion-background-color: #f6f6f6;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
}

ion-back-button {
  display: block;
}

ion-item {
  --ion-background-color: white;
  --border-style: none;
  --background-activated: none;
}

.activity-info-container {
  width: 350px;
  margin: 5px auto;
  display: block;
  background-color: white;
  padding: 10px;
  border-radius: 10px;
}

.activity-info {
  width: 350px;
  display: flex;
  flex-direction: row;
}

.activity-bonus-info {
  width: 300px;
}

.activity-customer-info {
  width: 325px;
  height: 25px;
  display: inline-block;
}

.activity-customer-normal {
  font-size: 16px;
}

.list-container {
  margin-top: 5px;
}

.login-title {
  font-size: 20px;
  display: block;
  width: 300px;
  height: 50px;
  margin: 50px auto;
}

.login-button {
  display: block;
  width: 300px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  margin: 0 auto;
  background-color: #d81e06;
  color: white;
  font-weight: bold;
  text-decoration-line: none;
}

.order {
  display: flex;
  margin: 5px auto;
  line-height: 100%;
  width: 355px;
  background-color: white;
  padding: 10px;
  border-radius: 10px;
  border-width: 0;
  flex-direction: column;
}

.order-no {
  font-size: 14px;
  color: gray;
  margin-top: 10px;
  margin-right: 10px;
  margin-bottom: 5px;
}

.order-shop-info {
  display: inline-flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 5px;
}

.order-shop-avatar {
  width: 65px;
  height: 65px;
  margin-left: 0;
  margin-right: 10px;
  display: block;
  background-size: cover;
  background-color: white;
  background-position: center;
}

.order-shop-sub-info {
  width: 100%;
}

.order-shop-name {
  font-size: 16px;
  font-weight: bold;
  word-break: break-all;
}

.order-status {
  display: inline-block;
  font-size: 12px;
  color: white;
  margin-top: 10px;
  margin-right: 10px;
  text-align: center;
  padding: 5px;
  border-radius: 4px;
}

.order-time-info {
  display: inline-flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 12px;
  color: gray;
  width: 335px;
}

.order-place-countdown {
  color: red;
}

.loading {
  padding: 5px;
  text-align: center;
}

.loading:before {
  display: inline-block;
  margin-right: 2px;
  vertical-align: middle;
  content: '';
  width: 20px;
  height: 20px;
  /*background: url(../../images/icon-loading.png) no-repeat;*/
  background-size: contain;
  animation: rotate 1s linear infinite;
}

.loading.complete:before {
  display: none;
}

.eleme-background-color {
  background-color: #1296db;
}

.meituan-background-color {
  background-color: #F89800;
}

.shop-name-copy {
  display: inline-block;
  font-size: 12px;
  color: white;
  height: 26px;
  margin-left: 10px;
  text-align: center;
  padding: 5px;
  border-radius: 4px;
}

.eleme-background {
  background-image: url(data:image/png;base64,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);
}

.meituan-background {
  background-image: url(data:image/png;base64,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);
}

.upload-image-list {
  display: inline-flex;
  flex-direction: row;
  justify-content: flex-start;
}

.upload-container {
  margin-top: 10px;
  position: relative;
}

.upload-image {
  width: 70px;
  height: 80px;
}


.button-container {
  display: inline-flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  height: 75px;
  position: fixed;
  bottom: 0;
  background-color: white;
  border-top-width: 1px;
  border-top-style: solid;
  border-top-color: #e2e2e2;
  z-index: 10000;
}

.button-half {
  display: inline-block;
  width: 320px;
  height: 50px;
  margin: 8px auto;
  text-align: center;
  color: white;
  background-color: #d81e06;
  border-radius: 25px;
  line-height: 50px;
}
</style>
